<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">带量采购信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="no" label="申报单号">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申报时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="createdUserName" label="申请人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="ownerDeptName" label="所属科室">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="hospitalName" label="申报机构">
                <el-input type="hospitalName" disabled placeholder="请输入申报机构" v-model="form.hospitalName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="annual" label="所属年度">
                <el-select :disabled="!editMode" v-model="form.annual" placeholder="请选择" @change="annualChange" style="width:100%">
                  <el-option v-for="item in AnnualOptions" :key="item.id" :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productNumber" label="产品数">
                <el-input type="productNumber" disabled placeholder="请输入产品数" v-model="form.productNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="totalNumber" label="总数量">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申报明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column prop="productName" label="产品" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="180"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="180"></el-table-column>
            <el-table-column prop="historyReferTo" label="近年历史参考" width="120"></el-table-column>
            <el-table-column prop="number" label=" 本次申报数量" width="140"></el-table-column>
            <el-table-column prop="addUpNumber" label="本年度累计报数量" width="180"></el-table-column>
            <el-table-column prop="warnNumber" label="预警阈值" width="140">
              <!-- <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入数量" type="warnNumber" min="0" :id="'warnNumber' + scope.$index" v-model="scope.row.warnNumber"></el-input>
              </template> -->
            </el-table-column>
            <el-table-column prop="stateName" label="追加标识" width="120"></el-table-column>
            <el-table-column prop="productRegistCertName" label="注册证名称" width="200"></el-table-column>
            <el-table-column prop="productRegistCertNo" label="注册证号" width="200"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品名称" prop="supplierProductName">
                <SelectTable :disabled="!editMode" :columns="applySupplierProductColumns" :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertName" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>

            <el-col :span="6">
              <el-form-item prop="supplierName" label="供应商">
                <el-input disabled v-model="childForm.supplierName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input disabled v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="currAddUpNumber" label="当前累计申报数量">
                <el-input disabled v-model="childForm.currAddUpNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="childNumberChange"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="warnNumber" label="预警阈值">
                <el-input-number :disabled="!editMode" v-model="childForm.warnNumber" :controls="false" placeholder="请填写预警阈值"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="单价">
                <el-input disabled v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetVolumePurchaseById,
  SaveVolumePurchase,
  RejectVolumePurchase,
  GetHistoryReferToProductNumber,
  GetVolumeDeclarationDetailById,
  GetVolumeDeclarationDetails
} from "@/api";
import { AnnualOptions, ApproveStatusOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  ApproveStatusOptions: ApproveStatusOptions,
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      form: {},
      AnnualOptions: AnnualOptions,
      rules: {
        annual: [
          { required: true, message: '请选择所属年度', trigger: 'blur' }
        ],
      },
      childFormRules: {
        warnNumber: [
          { required: true, message: " 预警阈值数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 1.00,
            message: " 预警阈值数量必须大于0",
            trigger: "blur",
          },
          { validator: this.validateLimitNumber, trigger: 'blur' }
        ],
        number: [
          { required: true, message: "本次申报数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "本次申报数量必须大于0",
            trigger: "blur",
          },
          // { validator: this.validateLimitNumber, trigger: 'blur' }
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectVolumePurchase,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      isCopy: false

    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      if (query.isCopy == 1) {
        this.handleCreated(query.id)
      } else {
        this.handleUpdate(query.id);
      }
    } else {
      this.handleAdd();
    }
    this.getProductList('');

    console.log(this.$route)
  },
  computed: {
    system_setting () {
      return this.$store.getters.system_setting;
    }
  },
  methods: {

    // 新建
    handleAdd () {
      this.resetForm();

      this.editMode = true;
      this.form.hospitalName = this.system_setting.hospitalName
      let year = this.$route.query.annual

      if (year) {
        this.form.annual = year * 1 + 1
        GetVolumeDeclarationDetails({ pageIndex: 1, pageSize: 200, annual: year })
          .then(res => {
            if (res.returnData.data && res.returnData.data.length > 0) {

              res.returnData.data.forEach(item => {
                GetHistoryReferToProductNumber({ supplierProductId: item.supplierProductId, annual: this.form.annual })
                  .then(res => {
                    console.log(res.returnData, " res.returnData");
                    item.historyReferTo = res.returnData.historyReferTo;
                    item.currAddUpNumber = res.returnData.addUpNumber;
                    item.stateName = res.returnData.state == 0 ? '否' : '是';
                  })

                this.form.details.push(item)
              })
              this.form.details.forEach((e, index) => {
                e.$index = index + 1;
              });

              this.autoTotalAmount();
              this.productNumberChange();
            } else {
              this.$my_message(`上一年度没有申报明细`, "warning");
              return false
            }
          });
      }
    },
    // 编辑
    handleUpdate (id) {
      GetVolumePurchaseById({ id })
        .then((res) => {
          // this.resetForm()
          this.form = res.returnData;
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });

          this.initWorkFlowProperty(this.form);
        });
    },
    handleCreated (id) {
      this.editMode = true;
      GetVolumeDeclarationDetailById({ id }).then((res) => {

        this.form = res.returnData;
        this.form.hospitalName = this.system_setting.hospitalName
        this.form.id = 0
        this.form.no = ''
        this.form.status = 2
        this.form.workFlowInstanceId = 0
        let now = this.parseTime(new Date())
        let user = this.userInfo
        this.form.createdUserName = user.name
        this.form.createdUser = user.id
        this.form.ownerDept = user.deptId
        this.form.ownerDeptName = user.deptName
        this.form.createdTime = now
        this.form.annual = res.returnData.annual

        let newDetail = {

          manufacturerName: res.returnData.manufacturerName,
          minUnit: res.returnData.minUnit,
          productName: res.returnData.productName,
          specName: res.returnData.specName,
          productRegistCertName: res.returnData.productRegistCertName,
          roductRegistCertNo: res.returnData.productRegistCertNo,
          // number: res.returnData.number,
          warnNumber: res.returnData.warnNumber,

        }
        this.form.details = [];
        this.form.details.unshift(newDetail);

        if (this.form.details) {
          this.form.details.map(item => {
            item.state = 0;
            item.stateName = '';
            item.supplierProductId = this.form.supplierProductId;
            item.manufacturerId = this.form.manufacturerId;
            item.minUnit = this.form.minUnit;
            item.productId = this.form.productId;
            item.specId = this.form.specId;
            item.productRegistCertId = this.form.productRegistCertId;
            item.productRegistCertNo = this.form.productRegistCertNo;
            item.minUnit = this.form.minUnit;
            item.addUpNumber = this.form.number;

            GetHistoryReferToProductNumber({ supplierProductId: res.returnData.supplierProductId, annual: this.form.annual })
              .then(res => {
                item.historyReferTo = res.returnData.historyReferTo;
                item.currAddUpNumber = res.returnData.addUpNumber;
                item.stateName = res.returnData.state == 0 ? '否' : '是';
              })

            return item
          })
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.productNumberChange(0);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        if (!this.form.details || this.form.details.length == 0) {
          this.$my_message("明细表不能为空", "warning")
          return
        }

        SaveVolumePurchase(this.form)
          .then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);

          }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;

      });
    },
    resetForm () {
      this.form = {
        "annual": '',
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // console.log(this.$route)
      // this.$router.push({ name: this.getMainPathName(this.$route.path), params: this.$route.params });
      // let params = this.$route.params
      // console.log(params)
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      // this.productNumberChange(0);
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      // this.autoTotalAmount();
      this.productNumberChange();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },
    annualChange () {
      this.form.details = []
    },
    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        "supplierProductId": '',
        productName: '',
        productId: '',
        "specId": '',
        "brand": "",
        "supplierId": '',
        "manufacturerId": '',
        "unit": "",
        "minUnit": "",
        "warnNumber": 0,
        "number": 0,
        "price": 0,
        "state": 0,
        "historyReferTo": 0,
        "currAddUpNumber": 0,
        addUpNumber: 0,
        stateName: '',
        packSpec: '',
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
      this.productNumberChange();
    },
    submitChildForm () {
      this.pushChildForm(true);
      this.productNumberChange();
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList('')
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId

        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {

      this.childForm.addUpNumber = this.childForm.currAddUpNumber + this.childForm.number;
      // this.autoAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },


    productChange (row) {
      let id = this.childForm.id
      this.childForm = Object.assign(this.childForm, row)
      this.childForm.id = id
      this.childForm.supplierProductId = row.id
      this.childForm.number = 1
      this.childForm.price = this.childForm.purchasePrice
      this.childForm.amount = this.childForm.price
      this.childForm.supplierProductNo = this.childForm.no
      this.childForm.remark = ''

      setTimeout(() => {
        this.$refs.number.focus()
        this.$refs.number.select()
      }, 1)


      this.childForm.historyReferTo = 0;
      this.childForm.currAddUpNumber = 0;
      this.childForm.state = 0;

      GetHistoryReferToProductNumber({ supplierProductId: row.id, annual: this.form.annual })
        .then(res => {
          this.childForm.historyReferTo = res.returnData.historyReferTo;
          this.childForm.currAddUpNumber = res.returnData.addUpNumber;
          this.childForm.stateName = res.returnData.state == 0 ? '否' : '是';
          // this.childForm.state = res.returnData.state;

          this.childForm.addUpNumber = this.childForm.currAddUpNumber + this.childForm.number;

          this.addUpNumberChange();
        })

      this.$refs.childForm.validateField('productName')
    },

    addUpNumberChange () {
      let addUpNumber = 0;
      let totalNumber = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        addUpNumber = element.currAddUpNumber * 1 + element.number * 1;
        totalNumber = element.number * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;

    },
    productNumberChange () {
      this.form.productNumber = this.form.details.length
    },

    getProductList (keyWord) {

      // query.pageIndex = 1
      // query.pageSize = 100
      // query.isDistribution = 1
      // query.isEnabled = 1
      // query.status = 2

      this.getSupplierProducts(//query)
        {
          keyWord: keyWord, pageIndex: 1, pageSize: 100, isDistribution: 1, isEnabled: 1,
          status: 2
        })
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
